import { useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "../language-switcher";
import useI18n from "../../i18n/useI18n";


const Header = memo(({ onRightSidebarToggle }) => {
    const navigate = useNavigate();
    const { t } = useI18n()

    useEffect(() => {
        // Load required CSS files for header
        const cssFiles = [
            "/assets/plugins/bootstrap/css/bootstrap.min.css",
            "/assets/css/main.css",
            "/assets/css/color_skins.css"
        ];

        cssFiles.forEach(href => {
            const existing = document.querySelector(`link[data-header-style="${href}"]`);
            if (existing) return;

            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            link.setAttribute("data-header-style", href);
            document.head.appendChild(link);
        });

        return () => {
            cssFiles.forEach(href => {
                const link = document.querySelector(`link[data-header-style="${href}"]`);
                if (link && link.parentNode) {
                    link.parentNode.removeChild(link);
                }
            });
        };
    }, []);

    const handleClick = (e) => {
        e.preventDefault();
    };
    const handleClickAnnouncements = (e) => {
        e.preventDefault();
        navigate("/announcement");
    };
    const handleClickApplications = (e) => {
        e.preventDefault();
        navigate("/applications");
    };
    const onClickLogout = (e) => {
        e.preventDefault();
        console.log("logout");
        localStorage.removeItem("token");
        navigate("/auth/login");
    };
    return (
        <nav className="navbar p-l-5 p-r-5">
            <ul className="nav navbar-nav navbar-left text-left"
            
            style={{display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'}}>
                <li>
                    <div className="navbar-header" style={{ display: 'flex', alignItems: 'center' }}>
                        <a href="#" className="bars" onClick={handleClick}></a>
                        <a className="navbar-brand" onClick={() => navigate("/dashboard")} style={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ cursor: 'pointer' }} src="/assets/images/yos-logo-w.png" width="40" alt="YOS Portal" />
                            <span style={{ cursor: 'pointer' }} className="m-l-10">YÖS Portal</span>
                        </a>
                        <span className="d-flex align-items-center" style={{ gap: '6px', marginLeft: '8px' }}>
                            <a
                                className="nav-link"
                                style={{padding: '0 10px 0 5px'}}
                                title={t("AUTH_NAV_YOUTUBE_TITLE")}
                                href="https://www.youtube.com/@yosdanismanim"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <svg
                                    width="23"
                                    height="23"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill="#ff0000"
                                        d="M23.498 6.186a3.02 3.02 0 0 0-2.122-2.138C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.376.548A3.02 3.02 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.02 3.02 0 0 0 2.122 2.138C4.495 20.5 12 20.5 12 20.5s7.505 0 9.376-.548a3.02 3.02 0 0 0 2.122-2.138C24 15.93 24 12 24 12s0-3.93-.502-5.814z"
                                    />
                                    <path fill="#ffffff" d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                </svg>
                            </a>
                            <a
                                className="nav-link"
                                style={{padding: '0 5px'}}
                                title={t("AUTH_NAV_INSTAGRAM_TITLE")}
                                href="https://www.instagram.com/yosdanismanim/?igsh=MTZ4cTB3ejBwcDVqbg%3D%3D#"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="/assets/images/instagram.svg"
                                    alt={t("COMMON_SOCIAL_INSTAGRAM")}
                                    width="24"
                                    height="24"
                                />
                            </a>
                        </span>
                    </div>
                </li>
                {/* <li>
                    <a href="#" title="Etkinlikler" onClick={handleClick}>
                        <i className="zmdi zmdi-calendar"></i>
                    </a>
                </li>
                */}
                {/* <li>
                    <a href="#" title="Posta Kutusu" onClick={handleClick}>
                        <i className="zmdi zmdi-email"></i>
                    </a>
                </li> */}
                {/* <li>
                    <a href="#" title="İletişim Listesi" onClick={handleClick}>
                        <i className="zmdi zmdi-account-box-phone"></i>
                    </a>
                </li> */}
                <li className="dropdown">
                    {/* <a
                        href="#"
                        title={t('ANNOUNCEMENTS_LIST_TITLE', 'Duyurular')}
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                        role="button"
                        onClick={handleClickAnnouncements}
                    >
                        <i className="zmdi zmdi-notifications"></i>
                        <div className="notify">
                            <span className="heartbit"></span>
                            <span className="point"></span>
                        </div>
                    </a> */}
                    <ul className="dropdown-menu pullDown">
                        <li className="body">
                            <ul className="menu list-unstyled">
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="media">
                                            <img className="media-object" src="/assets/images/xs/avatar2.jpg" alt="" />
                                            <div className="media-body">
                                                <span className="name">Sophia <span className="time">30min ago</span></span>
                                                <span className="message">There are many variations of passages</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="media">
                                            <img className="media-object" src="/assets/images/xs/avatar3.jpg" alt="" />
                                            <div className="media-body">
                                                <span className="name">Sophia <span className="time">31min ago</span></span>
                                                <span className="message">There are many variations of passages of Lorem Ipsum</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="media">
                                            <img className="media-object" src="/assets/images/xs/avatar4.jpg" alt="" />
                                            <div className="media-body">
                                                <span className="name">Isabella <span className="time">35min ago</span></span>
                                                <span className="message">There are many variations of passages</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="media">
                                            <img className="media-object" src="/assets/images/xs/avatar5.jpg" alt="" />
                                            <div className="media-body">
                                                <span className="name">Alexander <span className="time">35min ago</span></span>
                                                <span className="message">Contrary to popular belief, Lorem Ipsum random</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="media">
                                            <img className="media-object" src="/assets/images/xs/avatar6.jpg" alt="" />
                                            <div className="media-body">
                                                <span className="name">Grayson <span className="time">1hr ago</span></span>
                                                <span className="message">There are many variations of passages</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="footer">
                            <a href="#" onClick={handleClick}>View All</a>
                        </li>
                    </ul>
                </li>
                <li className="dropdown">
                    {/* <a
                        href="#"
                        title={t('SIDEBAR_APPLICATIONS')}
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                        role="button"
                        onClick={handleClickApplications}
                    >
                        <i className="zmdi zmdi-flag"></i>
                        <div className="notify">
                            <span className="heartbit"></span>
                            <span className="point"></span>
                        </div>
                    </a> */}
                    <ul className="dropdown-menu pullDown">
                        <li className="header">Department</li>
                        <li className="body">
                            <ul className="menu tasks list-unstyled">
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="progress-container progress-primary">
                                            <span className="progress-badge">Computer</span>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    aria-valuenow="86"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    style={{ width: '86%' }}
                                                >
                                                    <span className="progress-value">86%</span>
                                                </div>
                                            </div>
                                            <ul className="list-unstyled team-info">
                                                <li className="m-r-15">
                                                    <small className="text-muted">Team</small>
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar2.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar3.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar4.jpg" alt="Avatar" />
                                                </li>
                                            </ul>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="progress-container progress-info">
                                            <span className="progress-badge">Medical</span>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    aria-valuenow="45"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    style={{ width: '45%' }}
                                                >
                                                    <span className="progress-value">45%</span>
                                                </div>
                                            </div>
                                            <ul className="list-unstyled team-info">
                                                <li className="m-r-15">
                                                    <small className="text-muted">Team</small>
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar10.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar9.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar8.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar7.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar6.jpg" alt="Avatar" />
                                                </li>
                                            </ul>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleClick}>
                                        <div className="progress-container progress-warning">
                                            <span className="progress-badge">Art & Design</span>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    aria-valuenow="29"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    style={{ width: '29%' }}
                                                >
                                                    <span className="progress-value">29%</span>
                                                </div>
                                            </div>
                                            <ul className="list-unstyled team-info">
                                                <li className="m-r-15">
                                                    <small className="text-muted">Team</small>
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar5.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar2.jpg" alt="Avatar" />
                                                </li>
                                                <li>
                                                    <img src="/assets/images/xs/avatar7.jpg" alt="Avatar" />
                                                </li>
                                            </ul>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="footer">
                            <a href="#" onClick={handleClick}>View All</a>
                        </li>
                    </ul>
                </li>
                {/* <li>
                    <div className="input-group">
                        <input type="text" className="form-control" placeholder="Ara..."/>
                        <span className="input-group-addon">
                            <i className="zmdi zmdi-search"></i>
                        </span>
                    </div>
                </li> */}
                <li className="float-right d-flex align-items-center" style={{ gap: '10px' }}>
                    <LanguageSwitcher />
                    <a href="#" className="mega-menu" data-close="true" onClick={onClickLogout}>
                        <i className="zmdi zmdi-power"></i>
                    </a>
                    {/* <a 
                        href="#" 
                        className="js-right-sidebar" 
                        data-close="true" 
                        onClick={(e) => {
                            e.preventDefault();
                            if (onRightSidebarToggle) {
                                onRightSidebarToggle();
                            }
                        }}
                    >
                        <i className="zmdi zmdi-settings zmdi-hc-spin"></i>
                    </a> */}
                </li>
            </ul>
        </nav>
    );
});

export default Header;
